cockpitApp.directive('cookieBar', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/cookies',
    controllerAs: 'cookieBarCtrl',
    controller: 'cookieBarController'
  };
});
